<template>
    <section v-if="getSolicitationModule">
        <div class="form-module">
            <div class="type-select">
                <div class="type-select-group" @click="formType = 'pedidos'" :class="{'active-type': formType === 'pedidos'}">
                    <input class="form-control" type="radio" value="pedidos" name="type-select" v-model="formType">
                    <span>Pedidos</span>
                </div>
                <div class="type-select-group" @click="formType = 'solicitacoes'" :class="{'active-type': formType === 'solicitacoes'}">
                    <input class="form-control" type="radio" value="solicitacoes" name="type-select" v-model="formType">
                    <span>Solicitações</span>
                </div>
            </div>

            <transition name="fade">
                <div class="form-wrapper" :key="formType">
                    <form-header :banks="banksList" @update-info="updateInfo" :reloadForm="reset" :formType="formType" @change-subtype="changeSubtype" :subtypesList="subtypesList"></form-header>
                    <component v-if="formType === 'pedidos'" :is="formType" @cancel="reset = !reset" :cities="cities" @save="saveSolicitation" :saveLoading="saving" :reset="reset"/>
                    <component v-else-if="subtypeSelected.type === 'outros'" :is="'outros'" @cancel="reset = !reset" :cities="cities" @save="saveSolicitation" :saveLoading="saving" :reset="reset"/>
                    <component v-else-if="subtypeSelected.type.includes('outros-')" :is="'outrosEspecificos'" @cancel="reset = !reset" :cities="cities" @save="saveSolicitation" :saveLoading="saving" :reset="reset"/>
                    <component v-else :is="subtypeSelected.type" @cancel="reset = !reset" :cities="cities" @save="saveSolicitation" :saveLoading="saving" :reset="reset"/>
                    <span class="required-fields-caption">* campos obrigatórios</span>

                    <div id="attach-wrapper">
                        <div class="checkbox-group" @click="addAttach()">
                            <span><i class="fas fa-paperclip"></i> Anexar Arquivos</span>
                        </div>
                        <div class="composer-attachments" v-if="attachments.length > 0">
                            <h5>Anexos:</h5>
                            <ul>
                                <li v-for="(file, index) in attachments" :key="index">
                                    <span>
                                        <i :class="getFileIcon(file.name)"></i>
                                        <span>{{ textSizeLimit(file.name, 22) }}</span>
                                    </span>
                                    <button @click="removeAttach(index)" class="remove-attachment-btn" title="Remover anexo">✕</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex';
import formHeader from './FormHeader.vue';
import elogio from './Elogios.vue';
import ocorrenciaTransito from './OcorrenciaTransito.vue';
import condutaColaborador from './CondutaColaborador.vue';
import atraso from './AtrasoAtendimento.vue';
import outros from './Outros.vue';
import outrosEspecificos from './OutrosEspecificos.vue';
import cidades from './Cities.js'
import pedidos from './Pedidos.vue';
import moment from 'moment';

export default {
    data() {
        return {
            formType: 'pedidos',
            subtype: 'outros',
            banksList: [],
            clientInfo: {},
            reset: false,
            saving: false,
            cities: [],
            attachments: [],
            subtypesList: [],
            subtypeSelected: {}
        } 
    },
    computed: {
        ...mapGetters(['getSolicitationModule']),
    },
    components: {
        formHeader,
        elogio,
        ocorrenciaTransito,
        condutaColaborador,
        atraso,
        outros,
        pedidos,
        outrosEspecificos
    },
    async mounted() {
        await this.getBanks()
        await this.getCities()
        await this.getReasons()
    },
    methods: {
        async getBanks() {
            try {
                axios.get('/getBanks').then(({ data }) => {
                    if (data && data.length) {
                        this.banksList = data
                    }
                })
            } catch (error) {
                console.error('Erro ao buscar listagem de bancos: ', error)
            }
        },
        async getCities() {
            const arr = [];

            cidades.estados.forEach(estado => {
                estado.cidades.forEach(cidade => {
                    arr.push(`${cidade} - ${estado.sigla}`);
                });
            });

            this.cities = arr.sort((a, b) => a.localeCompare(b));
        },
        async getReasons(){
            axios.get('/getReasons').then(({data}) => {
                if(data && data.length){
                    data.map((el, index) => {
                        const temp = {
                            type: (el.component) ? el.component : `outros-${index}`,
                            label: el.name,
                            sla: el.sla,
                            sla_att: el.sla_att
                        }
                        this.subtypesList.push(temp)
                    })

                    if(this.subtypesList.length){
                        this.subtypeSelected = this.subtypesList[0]
                    } 
                }
            })
        },
        async updateInfo(info) {
            if (Object.keys(info).length) {
                this.clientInfo = { ...info }
            }
        },
        async saveSolicitation(form) {
            const isValid = await this.checkRequiredFields(form)

            if (isValid) {
                const payload = await this.formatPayload(form)
                if (payload) {
                    try {
                        this.saving = true
                        
                        const formData = new FormData();
                        const payloadCopy = { ...payload };
                        delete payloadCopy.attachments;

                        const appendToFormData = (data, formData, parentKey = '') => {
                            Object.keys(data).forEach(key => {
                                const value = data[key];
                                const formKey = parentKey ? `${parentKey}[${key}]` : key;
                                
                                if (value === null || value === undefined) {
                                    formData.append(formKey, '');
                                } else if (Array.isArray(value)) {
                                    // Arrays: adicionar cada item com []
                                    value.forEach((item, index) => {
                                        if (typeof item === 'object' && item !== null) {
                                            appendToFormData(item, formData, `${formKey}[${index}]`);
                                        } else {
                                            formData.append(`${formKey}[]`, item);
                                        }
                                    });
                                } else if (typeof value === 'object' && !(value instanceof File)) {
                                    // Objetos: recursão para achatar
                                    appendToFormData(value, formData, formKey);
                                } else {
                                    // Valores primitivos
                                    formData.append(formKey, value);
                                }
                            });
                        };
                        
                        appendToFormData(payloadCopy, formData);

                        // Adicionar arquivos
                        if (this.attachments && this.attachments.length > 0) {
                            this.attachments.forEach((file, index) => {
                                formData.append('attachments[]', file);
                            });
                        }

                        await axios.post('save-request', formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        })
                        Swal.fire({
                            title: 'Sucesso!',
                            html: `Solicitação salva com sucesso!`,
                            showCancelButton: false,
                            confirmButtonText: 'OK',
                            type: 'success',
                            showCloseButton: true,
                        });
                    } catch (error) {
                        Swal.fire({
                            title: 'Erro!',
                            html: `Erro ao salvar solicitação. Por favor, tente novamente.`,
                            showCancelButton: false,
                            confirmButtonText: 'OK',
                            type: 'warning',
                            showCloseButton: true,
                        });
                        console.error('Erro ao salvar solicitação: ', error)
                    }
                }
                this.saving = false
                this.reset = !this.reset
                this.attachments = []
            }
        },
        async checkRequiredFields(form) {
            const validateFields = (fields) => {
                for (const field of Object.entries(fields)) {
                    if (typeof field[1] === 'object' && field[1].required && (!field[1].value || !Object.keys(field[1].value).length)) {
                        Swal.fire({
                            title: 'Campo obrigatório!',
                            html: `O campo <strong>${field[1].label}</strong> é obrigatório!`,
                            showCancelButton: false,
                            confirmButtonText: 'OK',
                            type: 'warning',
                            showCloseButton: true,
                        });
                        return false;
                    }

                    if (field[0] === 'orderReview' && !field[1].value.length) {
                        Swal.fire({
                            title: 'Pedido vazio!',
                            html: `Não há itens adicionados no pedido! Adicione pelo menos um item para salvar a solicitação.`,
                            showCancelButton: false,
                            confirmButtonText: 'OK',
                            type: 'error',
                            showCloseButton: true,
                        });
                        return false;
                    }

                    if (
                        (field[0] === 'phone' && field[1].required && field[1].value.replace(/\D/g, '').length < 10) ||
                        (field[0] === 'cnpj' && field[1].required && field[1].value.replace(/\D/g, '').length < 14) ||
                        (field[0] === 'ag' && field[1].required && field[1].value.replace(/\D/g, '').length < 4)
                    ) {
                        Swal.fire({
                            title: 'Formato inválido!',
                            html: `Formato inválido no campo <strong>${field[1].label}</strong>!`,
                            showCancelButton: false,
                            confirmButtonText: 'OK',
                            type: 'warning',
                            showCloseButton: true,
                        });
                        return false;
                    }
                }
                return true;
            };

            if (!validateFields(this.clientInfo.general)) return false;
            if (this.clientInfo.general?.isClient) {
                if (!validateFields(this.clientInfo.client)) return false;
            }
            if (!validateFields(form.data)) return false;

            return true;
        },
        async formatPayload(form) {
            try {
                let clientType;
                let requestData = {}
                if (this.clientInfo.general.isClient) {
                    if (this.clientInfo.client.type === 'bank') {
                        clientType = 'bank'
                    } else {
                        clientType = 'client'
                    }
                } else {
                    clientType = 'notClient'
                }

                if(this.formType === 'solicitacoes'){
                    if(this.subtypeSelected.type === 'elogio'){
                        requestData = {
                            tipo: 'elogio',
                            nome: this.clientInfo.general.solicitant.value,
                            cidade: form.data.city.value,
                            descricao: form.data.description.value,
                            status: 'Aberto',
                            veiculo: false
                        }
                    } else if(this.subtypeSelected.type === 'ocorrenciaTransito'){
                        requestData = {
                            tipo: 'reclamacao',
                            assunto: 'transito',
                            data: moment(form.data.occurrenceDay.value, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                            hora: form.data.occurrenceHour.value,
                            cidade: form.data.city.value,
                            local: this.clientInfo.general.address.value,
                            placaSolicitante: form.data.solicitantLicensePlate.value,
                            veiculo: {
                                prefixo: form.data.prefix.value,
                                sufixo: form.data.sufix.value,
                                placa: form.data.licensePlate.value,
                                nomeBase: form.data.baseName.value,
                                siglaBase: form.data.baseAcronym.value
                            },
                            descricao: form.data.description.value,
                            status: 'Aberto'
                        }
                    } else if(this.subtypeSelected.type === 'condutaColaborador'){
                        requestData = {
                            tipo: 'reclamacao',
                            assunto: 'conduta',
                            local: this.clientInfo.general.address.value,
                            descricao: form.data.description.value,
                            cidade: form.data.city.value,
                            status: 'Aberto',
                            veiculo: false
                        }
                    } else if(this.subtypeSelected.type === 'atraso'){
                        requestData = {
                            tipo: "reclamacao",
                            assunto: "atraso",
                            data: moment(form.data.estimatedDay.value, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                            hora: form.data.estimatedHour.value,
                            descricao: form.data.description.value,
                            status: "Aberto",
                            veiculo: false
                        }
                    } else if(this.subtypeSelected.type.includes('outros')){
                        const reason = this.subtypeSelected?.label ?? 'Outros'
                        requestData = {
                            tipo: 'outros',
                            motivo: reason,
                            descricao: form.data.description.value,
                            status: 'Aberto'
                        }

                        if(this.subtypeSelected.type === 'outros') requestData.assunto = form.data.subject.value
                    }
                } else {
                    const orderArray = form.data.orderReview.value
                    let malote = false;
                    let gtv = false;
                    let orderType = ''
                    let order = []
                    orderArray.map(el => {
                        if (el.type.includes('Malote') || el.type.includes('Bananinha')) malote = true
                        if (el.type.includes('GTV')) gtv = true
                        order.push(`${el.type} - ${el.quantity}`)
                    })

                    if (form.data.description.value) {
                        order.push(`OBS: ${form.data.description.value}`)
                    }

                    if (malote && gtv) orderType = 'Malote e GTV'
                    if (!malote && gtv) orderType = 'GTV'
                    if (malote && !gtv) orderType = 'Malote'

                    requestData = {
                        solicitacao: orderType,
                        status: 'Aberto',
                        tipo: order,
                    }
                }

                const obj = {
                    client: this.clientInfo.general.solicitant.value,
                    client_id: '55' + this.clientInfo.general.phone.value.replace(/\D/g, '') + '@operatorForm_'  + moment().unix(),
                    email: this.clientInfo.general.email.value,
                    cnpj: this.clientInfo.client.cnpj.value || null,
                    created_at: moment().format('YYYY-MM-DD HH:mm:ss'),
                    name: this.clientInfo.general.solicitant.value,
                    type: clientType,
                    protocol: this.clientInfo.general.protocol.value,
                    attProtocol: this.clientInfo.general.attProtocol.value,
                    sla: this.subtypeSelected?.sla ?? null,
                    sla_att: this.subtypeSelected?.sla_att ?? null,
                    updated_at: moment().format('YYYY-MM-DD HH:mm:ss'),
                    attachments: this.attachments ?? [],
                    channel: this.clientInfo.general.channel.value
                }

                if (this.formType !== 'pedidos') {
                    obj.relato = requestData
                } else {
                    obj.pedido = requestData
                }

                if (this.clientInfo.general.isClient) {
                    obj.clientInfo = {
                        NomeCliente: this.clientInfo.client.name.value || '',
                        NomePonto: this.clientInfo.client.fantasyName.value || '',
                        CodigoPonto: this.clientInfo.client.cod.value || '',
                        EnderecoPonto: this.clientInfo.general.address.value || '',
                        Base: this.clientInfo.client.base.value || ''
                    }

                    if(this.formType === 'solicitacoes' && this.subtypeSelected.type.includes('outros')){
                        const nomeCliente = obj.clientInfo.NomeCliente.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9]/g, '').toLowerCase()
                        if (obj.clientInfo.NomeCliente && nomeCliente.includes('itau')) {
                            obj.relato.motivo += ' - Itaú'
                        } else {
                            obj.relato.motivo += ' - Demais Clientes'
                        }
                    }
                }

                return obj
            } catch (error) {
                console.error(error)
                return null
            }
        },
        changeSubtype(subtype){
            this.subtypeSelected = subtype
        },
        addAttach() {
            if (this.attachments.length >= 10) {
                Swal.fire({
                    title: 'Limite de arquivos excedido',
                    text: 'É possível anexar no máximo 10 arquivos.',
                    type: 'warning',
                    confirmButtonText: 'OK'
                });
                return;
            }

            const input = document.createElement('input');
            input.type = 'file';
            input.multiple = true;
            input.onchange = (e) => {
                const files = Array.from(e.target.files);
                const remainingSlots = 10 - this.attachments.length;

                if (files.length > remainingSlots) {
                    Swal.fire({
                        title: 'Limite de arquivos excedido',
                        text: `É possível anexar no máximo 10 arquivos.`,
                        type: 'warning',
                        confirmButtonText: 'OK'
                    });
                    this.attachments = [...this.attachments, ...files.slice(0, remainingSlots)];
                } else {
                    this.attachments = [...this.attachments, ...files];
                }
            };
            input.click();
        },
        removeAttach(index) {
            this.attachments.splice(index, 1);
        },
        getFileIcon(fileName) {
            const extension = fileName.split('.').pop().toLowerCase();
            const iconMap = {
                // Imagens
                'jpg': 'fas fa-file-image',
                'jpeg': 'fas fa-file-image',
                'png': 'fas fa-file-image',
                'gif': 'fas fa-file-image',
                'bmp': 'fas fa-file-image',
                'svg': 'fas fa-file-image',
                // Documentos
                'pdf': 'fas fa-file-pdf',
                'doc': 'fas fa-file-word',
                'docx': 'fas fa-file-word',
                'xls': 'fas fa-file-excel',
                'xlsx': 'fas fa-file-excel',
                'ppt': 'fas fa-file-powerpoint',
                'pptx': 'fas fa-file-powerpoint',
                'txt': 'fas fa-file-alt',
                // Áudio
                'mp3': 'fas fa-file-audio',
                'wav': 'fas fa-file-audio',
                'ogg': 'fas fa-file-audio',
                // Vídeo
                'mp4': 'fas fa-file-video',
                'avi': 'fas fa-file-video',
                'mov': 'fas fa-file-video',
                'mkv': 'fas fa-file-video',
                // Arquivos compactados
                'zip': 'fas fa-file-archive',
                'rar': 'fas fa-file-archive',
                '7z': 'fas fa-file-archive',
                // Código
                'html': 'fas fa-file-code',
                'css': 'fas fa-file-code',
                'js': 'fas fa-file-code',
                'json': 'fas fa-file-code',
                'xml': 'fas fa-file-code',
                'php': 'fas fa-file-code',
                'py': 'fas fa-file-code',
                // Padrão
                default: 'fas fa-file-alt'
            };

            return iconMap[extension] || iconMap.default;
        },
        textSizeLimit(text = "", size = 100) {
            if (typeof text != "string" || typeof size != "number") return text;
            const pontoIndex = text.lastIndexOf('.');

            if (pontoIndex === -1) {
                return text.substring(0, size);
            }

            const extensao = text.substring(pontoIndex);
            const nome = text.substring(0, pontoIndex);

            const tamanhoDisponivel = size - extensao.length;

            if (tamanhoDisponivel <= 0) {
                return extensao.substring(0, size);
            }

            return nome.substring(0, tamanhoDisponivel) + extensao;
        }
    },
    watch: {
        formType(value) {
            this.clientInfo = {}
        }
    }
}
</script>

<style lang="scss" scoped>
.fade-enter-active {
    transition: opacity 0.5s ease;
}

.fade-enter {
    opacity: 0;
}

.fade-leave-to {
    opacity: 0;
}

.active-type {
    background-color: #ededed;
}

.required-fields-caption {
    font-size: smaller;
    color: red;
    font-weight: bold;
}

.form-module {
    display: flex;
    flex-direction: column;
    padding: 10px;
    padding-top: 40px;

    .form-title {
        display: flex;
        justify-content: center;
        gap: 10px;
        width: 100%;
        margin: 20px;

        i {
            align-content: center;
            font-size: x-large;
        }

        span {
            font-size: x-large;
            font-weight: bold;
        }
    }

    .type-select {
        display: flex;
        justify-content: center;
        width: 100%;
        gap: 30px;
        flex-wrap: wrap;

        &-group {
            display: flex;
            gap: 5px;
            padding: 2px 10px;
            cursor: pointer;
            border: 1px solid #ededed;
            border-radius: 10px;
            box-shadow: 1px 1px 2px 0px lightgray;
            transition: ease-in-out 0.2s;

            span {
                white-space: nowrap;
                align-content: center;
                font-size: medium;
                font-weight: bold;
            }

            input {
                box-shadow: none;
                cursor: pointer;
            }

            &:hover {
                background-color: #ededed;
            }
        }
    }

    .form-wrapper {
        border: 1px solid #ededed;
        border-radius: 10px;
        box-shadow: 1px 1px 2px 0px lightgray;
        margin-top: 10px;
        padding: 10px;
    }
}

.checkbox-group {
    display: flex;
    gap: 5px;
    width: 150px;
    margin: 10px 0px;
    padding: 2px 10px;
    height: fit-content;
    align-self: end;
    cursor: pointer;
    border: 1px solid #ededed;
    border-radius: 10px;
    box-shadow: 1px 1px 2px 0px lightgray;
    transition: ease-in-out 0.2s;

    span {
        white-space: nowrap;
        align-content: center;
        font-weight: bold;
    }

    &:hover {
        background-color: #ededed;
    }
}

.composer-attachments {
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #eee;
}

.composer-attachments>h5 {
    font-size: 13px;
    margin: 0 0 10px 0;
}

.composer-attachments>ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
}

.composer-attachments>ul>li {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background: #f1f1f1;
    padding: 4px 8px;
    border-radius: 3px;
    font-size: 12px;
}

.composer-attachments>ul>li>span {
    display: flex;
    align-items: center;
    gap: 5px;
}

.remove-attachment-btn {
    background: none;
    border: none;
    color: #dc3545;
    font-weight: bold;
    cursor: pointer;
    font-size: 14px;
    padding: 0 5px;
}
</style>